export const COMPANY_NAME_SUBTITLE_KEYWORDS: string[] = [
    'river lake',
    'foodcourt',
    'food-court',
    'restaurant',
    'cafe',
    'coffee',
    'bar',
    'bistro',
    'bakery',
    'kitchen',
    'diner',
    'grill',
    'pub',
    'lounge',
];

export interface ISmartBusinessTitle {
    hasSmartSubtitle: boolean;
    mainTitle: string;
    subtitle: string;
}

const normalizeKeyword = (keyword: string): string[] =>
    keyword.trim().toLowerCase().split(/\s+/);

const titleEndsWithKeyword = (titleParts: string[], keywordParts: string[]): boolean =>
    titleParts.length > keywordParts.length &&
    keywordParts.every(
        (keywordPart, index) =>
            titleParts[titleParts.length - keywordParts.length + index]?.toLowerCase() === keywordPart
    );

export const getSmartBusinessTitle = (title: string): ISmartBusinessTitle => {
    const normalizedTitle = title.trim().replace(/\s+/g, ' ');
    const titleParts = normalizedTitle.split(' ');

    if (titleParts.length <= 1) {
        return {
            hasSmartSubtitle: false,
            mainTitle: normalizedTitle,
            subtitle: '',
        };
    }

    const subtitleKeywords = [...COMPANY_NAME_SUBTITLE_KEYWORDS].sort(
        (a, b) => normalizeKeyword(b).length - normalizeKeyword(a).length
    );

    for (const keyword of subtitleKeywords) {
        const keywordParts = normalizeKeyword(keyword);

        if (!titleEndsWithKeyword(titleParts, keywordParts)) {
            continue;
        }

        const subtitleParts = titleParts.slice(-keywordParts.length);

        return {
            hasSmartSubtitle: true,
            mainTitle: titleParts.slice(0, -keywordParts.length).join(' '),
            subtitle: subtitleParts.join(' '),
        };
    }

    return {
        hasSmartSubtitle: false,
        mainTitle: normalizedTitle,
        subtitle: '',
    };
};
